import { __decorate } from "tslib";
import { Component, Prop } from "../../../vue";
import SchemaBaseView from "./SchemaBaseView";
let SchemaCreateView = class SchemaCreateView extends SchemaBaseView {
  constructor() {
    super(...arguments);
    this.mode = 'create';
    this.formData = {
      id: '',
      type: 'string'
    };
  }
  get schema() {
    return this.formData;
  }
  created() {
    const updateItems = () => {
      if (this.isArray) {
        this.$set(this.formData, 'items', {
          type: this.itemsType
        });
      } else {
        this.$delete(this.formData, 'items');
      }
    };
    updateItems();
    this.$watch(() => this.itemsType, updateItems);
    this.$watch(() => this.isArray, updateItems);
  }
  async onSave() {
    const isOk = await this.validateForm();
    if (!isOk) return;
    const res = {
      action: 'ok',
      success: true,
      schema: this.formData
    };
    this.$emit('msg', res);
  }
  onCancel() {
    const res = {
      action: 'cancel',
      success: false
    };
    this.$emit('msg', res);
  }
  render() {
    return this.renderForm();
  }
};
__decorate([Prop()], SchemaCreateView.prototype, "options", void 0);
SchemaCreateView = __decorate([Component({
  name: 'SchemaCreateView'
})], SchemaCreateView);
export default SchemaCreateView;
//# sourceMappingURL=SchemaCreateView .js.map
